/**
 * Wait for fonts to be loaded before executing callback
 * Prevents SplitText from calculating incorrect dimensions
 */
export const waitForFonts = async (): Promise<void> => {
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready
  }
}

/**
 * Wait for both fonts and preloader to complete
 * Use this for components that need both conditions
 */
export const waitForFontsAndPreloader = (): Promise<void> => {
  return new Promise((resolve) => {
    const checkReady = async () => {
      await waitForFonts()

      if ((window as any).preloaderComplete) {
        resolve()
      } else {
        window.addEventListener('preloader:complete', () => resolve(), {
          once: true,
        })
      }
    }

    checkReady()
  })
}
